<template>
    <div @click="backToTop"
        class="w-[45px] h-[45px] rounded-full bg-blue-dark border border-white-light shadow-lg flex justify-center items-center cursor-pointer">
        <FontAwesomeIcon class="text-white" :icon="['fa', 'chevron-up']" />
    </div>
</template>

<script>
export default {
    methods: {
        backToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    }
};
</script>
